import * as React from "react";
import { CancelButton } from "@deliverr/ui-facility/lib-facility/components";
import { useBackToScanAny } from "./useBackToScanAny";

export const BackToScanAnyButton: React.FC = () => {
  const onClick = useBackToScanAny();
  return <CancelButton onClick={onClick} secondary block />;
};
